import { render } from "./ContributeComp.vue?vue&type=template&id=5acac42c&scoped=true"
import script from "./ContributeComp.vue?vue&type=script&lang=js"
export * from "./ContributeComp.vue?vue&type=script&lang=js"

import "./ContributeComp.vue?vue&type=style&index=0&id=5acac42c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acac42c"]])

export default __exports__